module.exports = __webpack_public_path__ + "img/back.781fea94.jpg";